/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-conditional */
/* eslint-disable react/no-unknown-property */
/**
 * @author Vladislavs Zimnikovs <vladislavs.zimnikovs@scandiweb.com>
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package puma-mx
 */

import Html from 'Component/Html';
import TextPlaceholder from 'Component/TextPlaceholder';
import { ProductInformation as SourceComponent } from 'SourceComponent/ProductInformation/ProductInformation.component';

import './ProductInformation.style.override';

/** @namespace Scandipwa/Component/ProductInformation/Component */
export class ProductInformationComponent extends SourceComponent {
    renderContent() {
        const { areDetailsLoaded, product: { description } } = this.props;
        const heading = description || areDetailsLoaded ? __('ABOUT PRODUCT') : <TextPlaceholder length="long" />;

        return (
            <div
                // show placeholder if the details are not loaded
              mix={ { block: 'ProductInformation', elem: 'Content' } }
            >
                <h2>
                    { heading }
                </h2>
                { description || areDetailsLoaded
                    ? this.renderDescription()
                    : (
                        <TextPlaceholder
                          content={ false }
                          mix={ { block: 'ProductInformation', elem: 'ContentPlaceholder' } }
                          length="long"
                        />
                    ) }
            </div>
        );
    }

    renderDescription() {
        const {
            product: {
                meta_description,
                description: {
                    html = ''
                } = {}
            },
            areDetailsLoaded
        } = this.props;

        if (!html && areDetailsLoaded) {
            return null;
        }
        const matchedContent = html.match(/<p>(.*?)<\/p>/g);
        const cleanedUpContent = matchedContent ? html.match(/<p>(.*?)<\/p>/g)[0]?.replace(/<[^>]*>/g, '') : '';
        // eslint-disable-next-line max-len, no-magic-numbers
        const htmlContent = matchedContent && html.match(/<p>(.*?)<\/p>/g).length === 1 && html.match(/<h3>/g).length === 3
            ? `${html.replace('</p>', '</p><div class="FirstBlock">') }</div>` : html;

        const productsDescriptionString = meta_description || cleanedUpContent || '';

        return (
            <div block="ProductInformation" elem="Description">
                <meta itemProp="description" content={ productsDescriptionString } />
                <Html content={ htmlContent } />
                { this.renderAdditionalDescription('care_instructions') }
                { this.renderAdditionalDescription('material_composition') }
            </div>
        );
    }

    renderAdditionalDescription(attributeCode) {
        const { product: { attributes } } = this.props;

        const { attribute_value, attribute_label } = attributes[attributeCode] || {};

        if (!attribute_label || !attribute_value) {
            return null;
        }

        return (
            <Html content={ `<h3>${ attribute_label.toUpperCase() }</h3> ${ attribute_value }` } />
        );
    }
}

export default ProductInformationComponent;
